import type {IAugmentedJQuery, IOnDestroy, IOnInit, IPostLink, IScope} from 'angular';

/**
 * @ngdoc controller
 * @name AbstractClassAddingController
 * @module portaro.components
 *
 * @abstract
 *
 * @requires $element
 * @requires $scope
 *
 * @description
 * This is abstract controller, which adding to extending component class monitoring and adding functionality.
 *
 * It creates observer on wrapping element and if some class is added to wrapper it extract this classes, removes from the wrapper and add classes to `public classes: string[]` property.
 * It does not support class removing.
 */
export default abstract class AbstractClassAddingController implements IOnInit, IPostLink, IOnDestroy {
    public classes: string[];
    protected element: HTMLElement;
    private mutationObserver: MutationObserver;

    /*@ngInject*/
    protected constructor($element: IAugmentedJQuery, private $scope: IScope) {
        this.element = $element[0];
    }

    public $onInit(): void {
        this.mutationObserver = new MutationObserver(((mutations) => {
            let apply = false;
            let classes;

            for (const mutation of mutations) {
                if (mutation.oldValue.trim() === '' && (mutation.target as HTMLElement).classList.length > 0) {
                    classes = (mutation.target as HTMLElement).className.split(' ');
                    this.classes.push(...classes);
                    this.element.className = '';
                    apply = true;
                }
            }

            if (apply) {
                this.$scope.$applyAsync();
            }
        }));
    }

    public $postLink(): void {
        this.classes = [...this.element.classList];
        this.element.className = '';

        this.mutationObserver.observe(this.element, {
            attributes: true,
            attributeOldValue: true,
            attributeFilter: ['class']
        });
    }

    public $onDestroy(): void {
        this.mutationObserver.disconnect();
    }

}
